import React, { useEffect } from "react";
import { Box, Grid, IconButton } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

import EntriesId from "../FundedCompliance/components/EntriesIdWithPrefix";
import * as Component from "./components";
import { MainInfoValue, Table } from "../../components/ui";
import { fundedComplianceProfileActions } from "../../reducers/fundedComplianceProfile";
import { FUNDED_COMPLIANCE_API_URLS, FundedComplianceAPI } from "../../api/fundedCompliance";
import { ACCOUNTS_MAIN_DATA_COLUMNS, ACTIVE_WITHDRAWALS_COLUMNS } from "./constants";

const FundedComplianceProfile = (): React.ReactElement => {
  const history = useHistory();
  const params: { id: string } = useParams();
  const id = +params.id;

  const dispatch = useDispatch();
  const { mainData } = useSelector((state) => state.fundedComplianceProfile);

  const { isError, error } = useQuery({
    queryKey: [FUNDED_COMPLIANCE_API_URLS.traderProfile, id],
    queryFn: async () => {
      dispatch(fundedComplianceProfileActions.fetchProfileRequest());
      const response = await FundedComplianceAPI.getTraderProfileRequest(id);
      dispatch(fundedComplianceProfileActions.fetchProfileSuccess(response.data));
      return response.data;
    },
  });

  const handleOnClick = () => history.goBack();

  useEffect(() => {
    if (isError && error) {
      dispatch(fundedComplianceProfileActions.fetchProfileFailed());
    }
  }, [isError, error]);

  return (
    <div className="customer">
      <Box className="title" display="flex">
        <IconButton color="inherit" onClick={handleOnClick}>
          <ArrowBackIosNewIcon />
        </IconButton>
        <MainInfoValue title="Trader ID">
          <EntriesId entriesId={id} />
        </MainInfoValue>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Component.Notes />
        </Grid>
      </Grid>

      <Table
        columns={ACCOUNTS_MAIN_DATA_COLUMNS}
        data={mainData.data.trader_accounts}
        extractKey={(row) => row.id}
        loading={mainData.isLoading}
        theadTitle="Evaluation accounts"
        csv_table_name="Evaluation accounts"
        noResultsMessage="There are no evaluation accounts"
      />

      <Component.CurrentPNL />

      <Table
        columns={ACTIVE_WITHDRAWALS_COLUMNS}
        data={mainData.data.withdrawals}
        extractKey={(row) => row.id}
        loading={mainData.isLoading}
        theadTitle="Withdrawals"
        csv_table_name="Withdrawals"
        noResultsMessage="There are no withdrawals"
      />

      <Component.WatchlistNotes />
      <Component.Passes />
      <Component.LiveSimTif />
      <Component.HeliosAppiusKronosLiveTif />
      <Component.Failed />
      <Component.TCPsteps />
      <Component.GauntCappers />
      <Component.FundedAccounts />
    </div>
  );
};

export default FundedComplianceProfile;
